/**
 * Hand the browser a file this client already holds.
 *
 * Every read here is behind a bearer token, so a plain link to the
 * address would be refused: the bytes are fetched like any other
 * response and saved from memory.
 */
export function download(filename: string, body: string, type: string): void {
  const url = URL.createObjectURL(new Blob([body], { type }))
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.click()
  URL.revokeObjectURL(url)
}
